import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {TeamInvitationComponent} from './team-invitation.component';
import {ReadMoreModule} from '../read-more/read-more.module';


@NgModule({
  declarations: [TeamInvitationComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReadMoreModule
  ],
  exports: [
    TeamInvitationComponent
  ]
})
export class TeamInvitationModule {
}
